import * as React from 'react';
import { ProgressBarColor, ProgressBarHeight, ProgressBar } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { FileUploadError } from "../../file";
import { UPLOAD_FAILED, NETWORK_ERROR_MESSAGE, PHOTO_CAPTURE, RETRY_UPLOAD, UPLOADING_FILES, CANCEL_UPLOAD } from '../constants';
import { StyledProgressBarContainer, StyledProgressBar, StyledRetryButton, StyledCancelUploadDiv, StyledUploadFailedIcon } from './PhotoCaptureFileUploadProgressBar.style';
export const PhotoCaptureFileUploadProgressBar = ({ files, isFileUploadStarted, errorMessage, showRetryAll, onCancel, onClose, onRetryAll, linkTextColor, buttonBackgroundColor = '', buttonTextColor = '', uploadError, children }) => {
    var _a, _b, _c;
    const translateFn = TranslationService.translate;
    const errorBanner = errorMessage
        ? errorMessage
        : ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.isUploadFailed) && ((_b = files[0].status) === null || _b === void 0 ? void 0 : _b.message);
    const onCancelClick = () => {
        files[0].id && onCancel(files[0].id);
        onClose();
    };
    const progressBar = (React.createElement(StyledProgressBarContainer, null,
        showRetryAll || errorBanner ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(StyledUploadFailedIcon, { className: "mi-icon-alert-filled-triangle" }),
                translateFn(UPLOAD_FAILED)),
            React.createElement(StyledProgressBar, null,
                React.createElement(ProgressBar, { color: ProgressBarColor.BLUE, height: ProgressBarHeight.SMALL, progress: 0 })),
            React.createElement("div", null,
                uploadError ? errorBanner : translateFn(NETWORK_ERROR_MESSAGE),
                " "),
            React.createElement(StyledRetryButton, { id: `${PHOTO_CAPTURE}_progress-bar`, label: translateFn(RETRY_UPLOAD), buttonBackgroundColor: buttonBackgroundColor, buttonTextColor: buttonTextColor, onClick: onRetryAll }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", null, translateFn(UPLOADING_FILES)),
            React.createElement(StyledProgressBar, null,
                React.createElement(ProgressBar, { color: ProgressBarColor.BLUE, height: ProgressBarHeight.SMALL, progress: files.length ? Math.trunc(files[0].progress || 0) : 0, isProgressPercentageDisplayed: true })))),
        React.createElement(StyledCancelUploadDiv, { color: linkTextColor, onClick: onCancelClick }, translateFn(CANCEL_UPLOAD))));
    const isUploadErrorExist = ((_c = files[0]) === null || _c === void 0 ? void 0 : _c.isUploadFailed) &&
        (uploadError === FileUploadError.MAX_VIDEO_FILE_SIZE_EXCEEDED || uploadError === FileUploadError.INVALID_FILE_TYPE)
        ? true
        : false;
    return isFileUploadStarted && !isUploadErrorExist ? progressBar : React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=PhotoCaptureFileUploadProgressBar.js.map